// Animations communes : apparition au défilement, compteurs et barre de progression.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;

  var REVEAL = [
    '.nca-known', '.nca-tiles > *', '.nca-stats > *', '.nca-split', '.nca-about', '.nca-cta', '.nca-faq',
    '.nca-values > *', '.nca-stat', '.nca-member', '.nca-steps li', '.nca-steps .nca-title', '.nca-team .nca-title',
    '.ncc-capteur > *', '.ncc-usp .ncc-wrap > *',
    '.ncp-block', '.ncp-cta', '.ncp-split', '.ncp-usp .ncp-wrap > *',
    '.ncx-compare__head', '.ncx-compare__table', '.ncx-help__head', '.ncx-help__grid > *', '.ncx-info__main', '.ncx-info__side', '.ncx-foot__grid > *',
    '.product-grid__item', '.resource-list__item'
  ].join(',');
  var COUNT = '.nca-stats > * strong, .nca-stats > * b, .nca-stat strong';

  function countUp(el) {
    var m = el.textContent.trim().match(/^(\d+)([\s\S]*)$/);
    if (!m || Number(m[1]) === 0) return;
    var end = Number(m[1]), rest = m[2], start = performance.now(), dur = 900;
    (function tick(now) {
      var p = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * e) + rest;
      if (p < 1) requestAnimationFrame(tick);
    })(start);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      io.unobserve(el);
      el.classList.add('is-in');
      if (el.matches(COUNT)) return countUp(el);
      var counter = el.querySelector(COUNT);
      if (counter) countUp(counter);
      // Retire la classe ensuite pour rendre la main aux effets de survol.
      setTimeout(function () { el.classList.remove('ncx-rv', 'is-in'); el.style.removeProperty('--ncx-d'); }, 1300);
    });
  }, {threshold: 0.12, rootMargin: '0px 0px -40px 0px'});

  document.querySelectorAll(REVEAL).forEach(function (el) {
    if (el.closest('.ncg, cart-drawer-component, .cart-drawer')) return;
    var i = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
    el.style.setProperty('--ncx-d', Math.min(i, 5) * 0.08 + 's');
    el.classList.add('ncx-rv');
    io.observe(el);
  });

  var bar = document.createElement('div');
  bar.className = 'ncx-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  var queued = false;
  function paint() {
    queued = false;
    var max = document.documentElement.scrollHeight - innerHeight;
    bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, scrollY / max) : 0) + ')';
  }
  addEventListener('scroll', function () { if (!queued) { queued = true; requestAnimationFrame(paint); } }, {passive: true});
  paint();
})();
